import axios from 'axios';

axios.defaults.timeout = 300000;


// 接口拦截配置
export const NOT_LOADING = 1;
export const NOT_MESSAGE = 2;
export const IS_MOBILE = 4;
export const NOT_REJECT = 8;

/**
 * 请求拦截器
 * @param {Object} config单独的配置
 * @param {Function} header
 * @param {Function} loading
 * @return {Function} 拦截器
 * */
export const requestUse = (config, { header, loading }) => {
  const baseConfig = config.expendConfig;
  // auth token
  config.headers.token = header();
  config.headers['If-Modified-Since'] = 0;
  // loading
  if (!(baseConfig & NOT_LOADING)) {
    loading(true);
  }
  return config;
};
/**
 * 响应器拦截
 * @param {Object} response返回对象
 * @param {Function} loading
 * @param {Function} messageError
 * @param {Function} message
 * @param {Function} loginOut
 * */
export const responseUse = (response, {
  loading, messageError, message, signOut, noRoot,
}) => {
  const { expendConfig, method } = response.config;
  let { status, data } = response;
  const msg = response.data.message;
  if (response.data.code === 200) {
    data = response.data.data; // eslint-disable-line
    status = +response.data.code;
  }
  const loadingFlag = !(expendConfig & NOT_LOADING);
  const messageFlag = !(expendConfig & NOT_MESSAGE);
  const rejectFlag = !(expendConfig & NOT_REJECT);
  // loading
  if (loadingFlag) {
    loading(false);
  }
  // 401暂无权限;403, 409登陆失效;
  if (status === 401) {
    messageError(noRoot);
    return Promise.reject(response);
  } if ([403, 409].includes(status)) {
    messageError(msg);
    signOut(true);
    return Promise.reject(response);
  }

  if (['get', 'delete'].includes(method)) {
    if (status !== 200) {
      if (messageFlag) {
        messageError(msg);
      }
      if (!(expendConfig & NOT_REJECT)) {
        return Promise.reject(response);
      }
    }
  } else if (['post', 'put'].includes(method)) {
    if (messageFlag && status !== 200 && msg) {
      message(msg);
      return Promise.reject(data);
    }
  }

  if (!rejectFlag) {
    return response;
  }
  return data || [];
};

/**
 * axiosGet创建
 * @param {String} url
 * @param {Object} params
 * @param {Object} axios实例
 * @param {Object} 配置项
 * */
export const axiosQuery = (method, url, params, instance = axios, config) => instance[method](url, { params, ...config }); // eslint-disable-line
/**
 * axiosPost创建
 * @param {String} url
 * @param {Object} params
 * @param {Object} axios实例
 * @param {Object} 配置项
 * */
export const axiosBody = (method, url, params, instance = axios, config) => instance[method](url, params, config); // eslint-disable-line
/**
 * 常用axios方法处理
 * @param {Object} axios实例
 * */
export const generatorApi = (instance = axios) => ({
  /**
   * 普通get或者post
   * @param {String} url
   * @param {Object} params
   * @param {Object} instanceTemp实例容器
   * @param {Object} 配置项
   * */
  get: (url, params, instanceTemp = instance, config) => axiosQuery('get', `/bigdata${url}`, params, instanceTemp, config),
  delete: (url, params, instanceTemp = instance, config) => axiosQuery('delete', `/bigdata${url}`, params, instanceTemp, config),
  post: (url, params, instanceTemp = instance, config) => axiosBody('post', `/bigdata${url}`, params, instanceTemp, config),
  put: (url, params, instanceTemp = instance, config) => axiosBody('put', `/bigdata${url}`, params, instanceTemp, config),
  loginGet: (url, params, instanceTemp = instance, config) => axiosQuery('get', `/loginApi${url}`, params, instanceTemp, config),

  // 不提示, 不loading
  getNoTips: (url, params) => axiosQuery('get', `/bigdata${url}`, params, instance, {
    expendConfig: NOT_LOADING | NOT_MESSAGE,
  }),
  userGetNoTips: (url, params) => axiosQuery('get', `/userApi${url}`, params, instance, {
    expendConfig: NOT_LOADING | NOT_MESSAGE,
  }),
  deleteNoTips: (url, params) => axiosQuery('delete', url, params, instance, {
    expendConfig: NOT_LOADING | NOT_MESSAGE,
  }),
  postNoTips: (url, params) => axiosBody('post', url, params, instance, {
    expendConfig: NOT_LOADING | NOT_MESSAGE,
  }),
  putNoTips: (url, params) => axiosBody('put', url, params, instance, {
    expendConfig: NOT_LOADING | NOT_MESSAGE,
  }),

  // 不提示
  getNoMessage: (url, params) => axiosQuery('get', url, params, instance, {
    expendConfig: NOT_MESSAGE,
  }),
  deleteNoMessage: (url, params) => axiosQuery('delete', url, params, instance, {
    expendConfig: NOT_MESSAGE,
  }),
  postNoMessage: (url, params) => axiosBody('post', url, params, instance, {
    expendConfig: NOT_MESSAGE,
  }),
  putNoMessage: (url, params) => axiosBody('put', url, params, instance, {
    expendConfig: NOT_MESSAGE,
  }),

  // 不Reject , 返回完整resp,
  getNoReject: (url, params) => axiosQuery('get', url, params, instance, {
    expendConfig: NOT_REJECT,
  }),
  deleteNoReject: (url, params) => axiosQuery('delete', url, params, instance, {
    expendConfig: NOT_REJECT,
  }),
  postNoReject: (url, params) => axiosBody('post', url, params, instance, {
    expendConfig: NOT_REJECT,
  }),
  putNoReject: (url, params) => axiosBody('put', url, params, instance, {
    expendConfig: NOT_REJECT,
  }),

  // 不Reject , 返回完整resp 不loading 不 message,
  getNoRejectNoTips: (url, params) => axiosQuery('get', url, params, instance, {
    expendConfig: NOT_REJECT | NOT_LOADING | NOT_MESSAGE,
  }),
  deleteNoRejectNoTips: (url, params) => axiosQuery('delete', url, params, instance, {
    expendConfig: NOT_REJECT | NOT_LOADING | NOT_MESSAGE,
  }),
  postNoRejectNoTips: (url, params) => axiosBody('post', url, params, instance, {
    expendConfig: NOT_REJECT | NOT_LOADING | NOT_MESSAGE,
  }),
  putNoRejectNoTips: (url, params) => axiosBody('put', url, params, instance, {
    expendConfig: NOT_REJECT | NOT_LOADING | NOT_MESSAGE,
  }),
});
